import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { ListItem } from '@xing-com/list';
import { ProgressBar } from '@xing-com/progress-bar';
import {
  scale130,
  scale230,
  spaceL,
  spaceM,
  xdlColorText,
} from '@xing-com/tokens';
import { BodyCopy, Meta } from '@xing-com/typography';

export const StyledListItem = styled(ListItem)`
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${spaceL};
`;

export const StyledProgressbar = styled(ProgressBar)`
  padding: ${spaceM} ${spaceM} 0 0;
  width: 100%;
`;

export const BodyCopyContainer = styled.div`
  overflow-wrap: break-word;
  width: calc(100% - ${scale230});
`;

export const StyledBodyCopy = styled(BodyCopy)`
  word-break: break-word;

  ${lineClamp(2)}
`;

export const IconContainer = styled.div`
  height: ${scale130};
  min-width: ${scale130};
  width: ${scale130};
`;

export const StyledButton = styled(Button)`
  height: auto;
`;

export const StyledMeta = styled(Meta)`
  margin: 0;
  && {
    color: ${xdlColorText};
  }
`;
